export default __webpack_public_path__ + "static/media/e5acf67d-3f9b-4688-a136-12b69e7263c0.4e2f7288.JPG";